export default function ProofOfConceptPage() {
  return (
    <div
      style={{
        backgroundImage:
          "url(https://static.igem.wiki/teams/4260/wiki/imagen/home/proof-of-concept/proofofcon-vertical-fondo.png)",
        width: "100vw"
      }}
    >
      <div className="w-full h-full py-20">
        <h1 className="text-6xl text-white text-center">PROOF OF CONCEPT</h1>
        <div
          className="max-w-4xl m-auto p-8 mt-8 rounded-md text-white"
          style={{ backgroundColor: "rgba(199, 48, 169,.80)" }}
        >
          <h3 className="h3">Overview</h3>
          <p className="p">
            This year’s project goal was to develop both a biosensor and a
            degradation system for Endocrine Disruptors present in waterways
            used for agriculture; these two systems, when coupled, would be able
            to prove effective at detecting and neutralizing EDCs present in
            irrigation waters. Therefore, preventing the spread of these
            contaminants to crops, and hence, halting the consumption of this
            nocive compound by humans. Due to the complex nature of implementing
            both systems, we ran different experiments to prove their
            effectiveness and applicability in a real world scenario.
          </p>
          <h3 className="h3">Exposure of crops to EDCs</h3>
          <p className="p">
            To determine the extent of the effects that EDCs have on plants when
            exposed chronically to these compounds, an experiment was conducted
            where Italian Lettuces received different doses of Carbamazepine so
            that possible morphological and physiological changes could be
            observed in the plants. Once the exposure periods ended, a clear
            morphological difference between the contaminated plants and the
            ones free of CBZ could be observed (Fig 1.)
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/proof-degra-lechuga23.jpg"
            alt="Degra lechuga 23"
            className="figure"
            width="400"
            height="500"
          />
          <p className="figure_desc">
            Fig 1a. CBZ (45 mg/mL) exposed plants after 22 days.
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/proof-degra-lechuga27.jpg"
            alt="Degra lechuga 27"
            className="figure"
            width="400"
            height="500"
          />
          <p className="figure_desc">
            Fig 1b. Plants not exposed to CBZ after 22 days.
          </p>
          <p className="p">
            Furthermore, when conducting an experimental analysis with lettuces irrigated with carbamazepine, we measured the leaf size, root size and realized a statistical analysis to obtain the significance of the effects caused by the CBZ concentration (4.5 mg/mL and 45 mg/mL) and time exposure (8 and 22 days) in an ANOVA analysis. It was found that the difference in leaf length between the controls and the experiments was significant in the greatest exposure time  and in the greatest concentration of carbamazepine (Figure 2). In figure 3, the pareto chart shows that the concentration of carbamazepine and the time exposure indeed are factors that affect the leaf length in lettuces. Furthermore, in the variance analysis (figure 4a) shows that the concentration of carbamazepine is significant in the leaf lengths due to the P-value, which is lower (0.002) than the value of trust (0.05), and finally, in figure 4b we show the value of the adjusted determination coefficient, which is 70.30%.
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/surfaceplotaverageleave.png"
            alt="surfaceplotaverageleave"
            className="figure"
          />
          <p className="figure_desc">
            <strong>Fig. 2 </strong> Surface plot analysis of the difference of leaf length between experimentals and controls.
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/paretochart.png"
            alt="paretochart"
            className="figure"
          />
          <p className="figure_desc">
            <strong>Fig. 3 </strong> Pareto chart in which factor A (CBZ concentration) and factor B (exposure time) are indeed significant in leaf length.
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/analysisofvariance.png"
            alt="paretochart"
            className="figure"
          />
          <p className="figure_desc">
            <strong>Fig. 4 </strong> <strong>A) Analysis of variance -</strong> P-value of the concentration of CBZ (0.002) is more little than the level of confidence (0.005) which accepts the hypothesis that CBZ concentration affects leaf length. <strong>B)  Model summary-</strong> adjusted determination coefficient of 70.3%.

          </p>
          <p className="p">
            Thus, confirming that CBZ concentration and exposure time had a negative impact on the growth of this specific crop. More information and the complete analysis can be found in Degradation Results.

          </p>
          <h3 className="h3">Biosensor</h3>
          <p className="p">
            Regarding the biosensor, it is important to mention two highlights
            in our wet lab that lead us to take important decisions:
          </p>
          <h3 className="h3">How to use chitosan for immobilization?</h3>
          <p className="p">
            Chitosan beads had many advantages but after the experiment reported
            in Measurement, it was stated the need for hERa to be superficially
            linked to the chitosan to let its ligand-binding domain roam free
            for EDCs to be caught and sensed. Additionally the use of gold
            nanoparticles enforces the signals sent to biosensor hardware and
            software.
          </p>
          <h3 className="h3">
            Is ESR1 being expressed with the improvements made to the part?
          </h3>
          <p className="p">
            Expression tests in E.coli BL21 transformed cells showed in SDS-PAGE
            the possible existence of hERa protein in the third lane, this
            concentration belonged to the periplasmic space where it was
            expected to be thanks to the signal peptide ompA. See Biosensor
            Results to know more about it.{" "}
          </p>
          <h3 className="h3">Degradation System</h3>
          <p className="p">
            Regarding the degradation system that was implemented, we utilized a
            laccase to carry out the degradation assays of EDCs (BPA).
            And, besides corroborating in the available literature the
            effectiveness of this reaction, the behavior of the laccase was
            analyzed in a Zetasizer at different conditions to confirm its
            functionality in open-air waterways.
          </p>
          <p className="p">
            By testing different pH conditions (Figure 4), it was determined
            that the protein (peak Y) was the most folded and, therefore more
            stable, at a pH 6; while the aggregates (peak X) were also the
            smallest at this pH.
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/teccemm-lacasaproofofconcepto.png"
            alt="zetasizer"
            className="figure"
          />
          <p className="figure_desc">
            <strong>Fig. 4 </strong> Protein size at different pHs. A) Media of the diameters of peak Y. B) Standard deviation of the diameters of peak Y. C) Media of the diameters of peak X. D) Standard deviation of the laccase diameters.
          </p>
          <p className="p">
            Hence, we conclude that the ideal conditions for a laccase to be deployed and put in action would be in a slightly acidic to neutral environment, just as irrigation waters usually are [1]
            The full analysis can be found on Degradation Results.
          </p>
          <h3 className="h3">Future steps</h3>
          <p className="p">
            Even though the research and development that has been carried out
            shows the viability and the real life application of our project,
            the team strives to carry out more experiments in order to expand
            the knowledge regarding the phenomena explored in this research.
            Henceforth, some future actions will be:
          </p>
          <ul class="list-disc pl-8">
            <li>
              To develop an immobilization protocol better suited for the laccase-zeolite interaction.
            </li>
            <li>
              To quantify the enzymatic activity of the laccase in specific substrates encountered in irrigation water (EDCs).
            </li>
            <li>
              To run experiments in situ to understand the interactions between the biosensor and the degradation system.
            </li>
          </ul>
          <p>
            <h3 className="h3">References</h3>
          </p>
          <p className="reference">
            [1] Douglas Cox. (2015, March 6). Water Quality: pH and Alkalinity. Center for Agriculture, Food and the Environment. https://ag.umass.edu/greenhouse-floriculture/fact-sheets/water-quality-ph-alkalinity
          </p>
        </div>
      </div>
    </div>
  );
}
